// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  campaignId: __t.u64().primaryKey().name("campaign_id"),
  version: __t.u32(),
  epoch: __t.u32(),
  pinned: __t.bool(),
  pinnedAt: __t.timestamp().name("pinned_at"),
  shots: __t.u64(),
  hits: __t.u64(),
  updatedAt: __t.timestamp().name("updated_at"),
});
